/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IHospitalInstitution } from 'app/shared/model/hospital-institution.model';
import { PackageType } from 'app/shared/model/enumerations/package-type.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { DiscPref } from 'app/shared/model/enumerations/disc-pref.model';

export interface IPaymentScheme {
  id?: string;
  name?: string | null;
  startDate?: number | null;
  endDate?: number | null;
  addedBy?: string | null;
  maxDiscountPercentage?: number | null;
  suspended?: boolean;
  suspendedReason?: string | null;
  suspendedDate?: number | null;
  suspendedBy?: string | null;
  packageType?: keyof typeof PackageType | null;
  serviceType?: keyof typeof PatientType | null;
  gracePeriod?: number | null;
  remindBefore?: number | null;
  proposedValue?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  pharmacyDiscPercent?: number | null;
  maxDiscountAmount?: number | null;
  maxCapAmount?: number | null;
  discPreference?: keyof typeof DiscPref | null;
  enforceCap?: boolean | null;
  extendedTarrifs?: boolean | null;
  labDiscPercent?: number | null;
  consDiscPercent?: number | null;
  procedureDiscPercent?: number | null;
  ipDiscPercent?: number | null;
  hospital?: IHospital;
  institution?: IHospitalInstitution | null;
}

export const defaultValue: Readonly<IPaymentScheme> = {
  suspended: false,
  active: false,
  enforceCap: false,
  extendedTarrifs: false,
};
